import { render, staticRenderFns } from "./NewsMarquee.vue?vue&type=template&id=70e02ec0&scoped=true&"
import script from "./NewsMarquee.vue?vue&type=script&lang=js&"
export * from "./NewsMarquee.vue?vue&type=script&lang=js&"
import style0 from "./NewsMarquee.vue?vue&type=style&index=0&id=70e02ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e02ec0",
  null
  
)

export default component.exports